import dayjs, { Dayjs } from "dayjs";

export function formatDate(date: Dayjs | null): string {
  if (date === null) {
    return "";
  }
  return dayjs(date).format("YYYY-MM-DDTHH:mm:ss");
}

export function stringToDateDaysJs(dateString: string): Dayjs | null {
  const parsedDate = dayjs(dateString);
  if (parsedDate.isValid()) {
    return parsedDate;
  } else {
    return null;
  }
}

 // Format number to BRL currency
  export function formatToBRL (value: number ): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  export function formatDateToDDMMYYYY(dataCriacao: string): string {
    const date = new Date(dataCriacao);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

export function formatDateToDDMMYYYYaddDays(dataCriacao: string, daysToAdd: number): string {
  const date = new Date(dataCriacao);

  // Adiciona os dias à data original
  date.setDate(date.getDate() + daysToAdd);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Mês começa em 0
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

  // Função para remover a máscara do documento
  export function limparMascaraDocumento (documento: string)  {
    return documento.replace(/\D/g, ''); // Remove todos os caracteres que não são dígitos
  };

  export function validateEmail (email: string) {
    // Simple email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  export function cnpjApplyMask(value: string) {
    return value.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    )
  }

  export function cpfApplyMask(value: string) {
    return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4")
  }

  export function formatPhoneNumberShort(value: string) {
    return value.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
  }

  export function formatPhoneNumberLong(value: string) {
    return value.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
  }